export default "__VITE_ASSET__CsUymFlS__"